module.exports = __webpack_public_path__ + "static/media/logo.55a87039.png";